import React from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import { PageInfoContainer } from "../styled/common";
import { FcHome } from "react-icons/fc";

const PageInfo = ({ title }) => {
  const { id } = useParams();
  const navigate = useNavigate();

  const user = useSelector((state) => state?.user?.data[0]);

  return (
    <>
      <PageInfoContainer>
        <div className="info">
          <div className="title">
            {!isNaN(id) && (
              <i onClick={() => navigate("/group")}>
                <FcHome />
              </i>
            )}
            <span onClick={() => (isNaN(id) ? navigate("/group") : navigate(`/group/${id}`))}>
              {title}
            </span>
          </div>
          <div className="actions">
            <button onClick={() => navigate("/group/all")}>전체 모임</button>
            {user &&
              ["feed", "my", "create"].map((path, idx) => (
                <button key={idx} onClick={() => navigate(`/group/${path}`)}>
                  {path === "feed" ? "전체 소식" : path === "my" ? "내 모임" : "나의 모임 만들기"}
                </button>
              ))}
          </div>
        </div>
      </PageInfoContainer>
    </>
  );
};

export default PageInfo;
